import { render } from "./Arrow.vue?vue&type=template&id=9a1a5d46&scoped=true"
import script from "./Arrow.vue?vue&type=script&lang=js"
export * from "./Arrow.vue?vue&type=script&lang=js"

import "./Arrow.vue?vue&type=style&index=0&id=9a1a5d46&lang=scss&scoped=true"

import exportComponent from "/home/mmelillo/development/suisseconsulences.ch/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9a1a5d46"]])

export default __exports__